<template>
    <v-expansion-panels class="mb-4">
        <v-expansion-panel>
            <v-expansion-panel-header>Tìm kiếm theo báo cáo marketing</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-card
                    class="ma-0 overflow-visible"
                    outlined
                >
                    <validation-observer v-slot="{ handleSubmit }">
                        <v-list-item class="pa-0" three-line>
                            <v-list-item-content class="overflow-visible pa-0">
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <validation-provider
                                            name="Chọn ngày"
                                            v-slot="{ errors }"
                                            rules="required"
                                        >
                                        <common-range-picker
                                            v-model="selectRange"
                                            :clearable="false"
                                            :aLight="'right'"
                                            :defaultRange="defaultRange"
                                            :minDate="'2021-04-27'"
                                            @change-date-range="changeDateRange"
                                        />
                                        <div class="v-text-field__details mt-1">
                                            <div class="v-messages theme--light error--text" role="alert">
                                                <div class="v-messages__wrapper">
                                                    <div class="v-messages__message">
                                                    {{ errors[0] }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <common-select-user
                                            v-model="filterForm.userIds"
                                            :items="users"
                                            item-text="fullName"
                                            item-value="id"
                                            label="Người phụ trách"
                                            color="primary"
                                            placeholder="Chọn người phụ trách"
                                            multiple
                                        />
                                    </v-col>
                                </v-row>
                                <div class="text-center mb-4">
                                    <v-btn
                                        class="primary mx-0"
                                        @click.prevent="handleSubmit(searchReport);"
                                    >
                                        <v-icon>mdi-magnify</v-icon>Tìm kiếm
                                    </v-btn>
                                </div>
                            </v-list-item-content>
                        </v-list-item>
                    </validation-observer>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import moment from 'moment'
export default {
    props: {
        filterForm: {
            type: Object,
            default: () => {},
        },
        users: {
            type: Array,
            default: () => {[]}
        }
    },
    data () {
        return {
            defaultRange: {
                startDate: moment().startOf('week').format('YYYY-MM-DD'),
                endDate: moment().endOf('week').format('YYYY-MM-DD'),
            },
            selectRange: [{
                startDate: moment().startOf('week').format('YYYY-MM-DD 00:00:00'),
                endDate: moment().endOf('week').format('YYYY-MM-DD 23:59:59'),
            }],
        }
    },
    methods: {
        searchReport () {
            Bus.$emit('marketing-report-by-marketer-list-filter', this.filterForm)
        },
        
        changeDateRange (dateRange) {
            this.filterForm.createdAt = [dateRange.startDate, dateRange.endDate]
            this.selectRange = dateRange
        }
    }
}
</script>